import React, { useEffect, useState } from "react"
import { useAppDispatch } from "../../../store"
import { setCurrentPage } from "../../../store/auth/authReducer"
import { Navigate, useLocation } from "react-router-dom"
import axios from "axios"
import Box from "@mui/material/Box"
import TextField from "@mui/material/TextField"
import Button from "@mui/material/Button"
import Snackbar from "@mui/material/Snackbar"
import Alert from "@mui/material/Alert"
import Select from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import FormControl from "@mui/material/FormControl"
import InputLabel from "@mui/material/InputLabel"
import { useSelector } from "react-redux"
import { logOut } from "../../../utils/logOut"
import { useSnackbar } from "../../../utils/SnackbarContext"
import TranslatedText from "../../../utils/Translate"

export default function ApiService() {
    const dispatch = useAppDispatch()
    const location = useLocation()
    const [openSnackbar, setOpenSnackbar] = useState(false)
    const [snackbarType, setSnackbarType] = useState("")
    const { showSnackbar } = useSnackbar();

    //Get params from URL
    const params = new URLSearchParams(location.search);
    const id = params.get('id');
    const type: string | null = params.get('type')

    //Get access level
    const accesslevel = useSelector(
        (state: any) => state.auth.authData.accesslevel
    )

    //Switch header title

    useEffect(() => {
        dispatch(setCurrentPage(type === "edit" ? `Edit API Service` : 'Add API Service'))
    }, [dispatch]);

    //Handle close snackbar
    const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };

    const getInitialApiService = () => ({
        name: '',
        type: '',
        order: ''
    })

    const [channels, setChannels] = useState([])
    const [partners, setPartners] = useState([])

    //Get user
    async function fetchData(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/apiservices/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })

            if (response.data !== null) {
                if (typeof (response.data) === 'object') {
                    setApiService({ ...getInitialApiService(), ...response.data[0] })
                }
                else showSnackbar('ERROR: INVALID SERVER RESPONSE', 'error')
            }

            console.log(response.data[0]);

        } catch (error: any) {
            console.log(error);
            if (error.code === "ERR_BAD_REQUEST") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Create contact group
    async function postData(data: any = {}) {
        try {
            const response = await axios.post(`https://cardgarantsales.com/restapi/apiservices`, {
                ...data
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })

            setSnackbarType('success')
            setOpenSnackbar(true)
        } catch (error: any) {
            setSnackbarType('error')
            setOpenSnackbar(true)
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Edit contact group
    async function putData(data: any = {}) {
        try {
            const response = await axios.put(`https://cardgarantsales.com/restapi/apiservices/${id}`, {
                ...data,
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })

            setSnackbarType('success')
            setOpenSnackbar(true)
        } catch (error: any) {
            setSnackbarType('error')
            setOpenSnackbar(true)
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }


    const [apiService, setApiService] = useState<any>(getInitialApiService())


    //On load if URL params contains type=edit
    useEffect(() => {
        type === 'edit' && fetchData()
        console.log(apiService);

    }, [type])

    return (
        <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
            <Box>
                <Box sx={{ width: 500, display: "flex", mb: 2, flexWrap: "wrap", gap: 2 }}>
                    <TextField sx={{ width: 500 }} label={<TranslatedText text={'Name'} />} variant="outlined" size="small" value={apiService.name || ''} onChange={(e) => setApiService({ ...apiService, name: e.target.value })} />
                    <TextField sx={{ width: 500 }} label={<TranslatedText text={'Type'} />} variant="outlined" size="small" value={apiService.type || ''} onChange={(e) => setApiService({ ...apiService, type: e.target.value })} />
                    <TextField sx={{ width: 500 }} label={<TranslatedText text={'Order'} />} variant="outlined" size="small" value={apiService.order || ''} onChange={(e) => setApiService({ ...apiService, order: e.target.value })} />
                </Box>
                <Button onClick={() => type === "edit" ? putData(apiService) : postData(apiService)} variant="contained" sx={{ width: "100%" }}>Save</Button>
            </Box>
            {type !== 'edit' && snackbarType === 'success' && <Navigate to='/apiservices' />}
            <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleClose}>
                {snackbarType === 'error' ?
                    <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
                        Saving error
                    </Alert> :
                    <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
                        Successfully saved
                    </Alert>}
            </Snackbar>
        </Box >
    )
}